/**
 * Created by contrapro on 03/04/2018
 */
import { ACTION_TYPE_SHOW_TIME_MODAL, ACTION_TYPE_CLOSE_TIME_MODAL } from '../actions';

const initialState = {
    title: '',
    content: '',
    modal: false,
    timeOver: null,
    okText:'',
};

export default function timeModalReducer(state = initialState, action) {
    switch (action.type) {
        case ACTION_TYPE_SHOW_TIME_MODAL:
            return Object.assign({}, ...state, {
                title: action.payload.data.title,
                content: action.payload.data.content,
                modal: true,
                timeOver: action.payload.data.timeOver
            });
        case ACTION_TYPE_CLOSE_TIME_MODAL:
            return Object.assign({}, ...state, {
                title: '',
                content: '',
                modal: false,
                timeOver: state.timeOver
            });
        default:
            return { ...state };
    }
}



// WEBPACK FOOTER //
// ./src/reducers/timeModalReducer.js